import React, { useState } from 'react';
import './Contact.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import halli1 from '../images/halli1.jpg';
import kartta from '../images/kartta.jpg';
import { useTranslation } from 'react-i18next';
import Seo from '../Components/Seo';

const Contact = () => {
  const [showMap, setShowMap] = useState(false);
  const { t, i18n } = useTranslation();
  const lang = i18n.language ? i18n.language.split('-')[0] : 'fi';

  return (
    <div className="Contactpage">
      <Seo
        title="Yhteystiedot"
        description="Katso Kempeleen Pyöräpajan yhteystiedot, sijainti ja aukioloajat ennen käyntiä tai yhteydenottoa."
        path="/contact"
      />
      <div className="contact-info">
        {/* Käytetään käännöksiä, mutta fallbackina oikeat tiedot */}
        <h2>{t('contact.title')}</h2>
        <h3 style={{ marginBottom: '2rem', fontWeight: 'normal', fontSize: '1.2rem' }}>{t('contact.name')}</h3>

        <p>
          <FontAwesomeIcon icon={faMapMarkerAlt} />
          {t('contact.address')}
        </p>

        <p>
          <FontAwesomeIcon icon={faEnvelope} />
          <a href={`mailto:${t('contact.email')}`} style={{ color: 'inherit', textDecoration: 'none' }}>
            {t('contact.email')}
          </a>
        </p>

        <p>
          <FontAwesomeIcon icon={faPhone} />
          <a href={`tel:${t('contact.phone').replace(/\s/g, '')}`} style={{ color: 'inherit', textDecoration: 'none' }}>
            {t('contact.phone')}
          </a>
        </p>

        <p style={{ marginTop: '2rem', fontSize: '0.9rem', fontStyle: 'italic' }}>
          {t('contact.contactInstruction')}
        </p>
      </div>

      <div className="contact-visuals">
        <img src={halli1} alt="Kempeleen Pyöräpaja Halli" className="hall-image" width="800" height="600" />

        <div style={{ marginBottom: '1rem', textAlign: 'center' }}>
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(t('contact.address'))}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#4CAF50', textDecoration: 'none', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}
          >
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            {t('contact.openMap')}
          </a>
        </div>

        <div className="map-container">
          {!showMap ? (
            <div className="map-placeholder" onClick={() => setShowMap(true)}>
              <img src={kartta} alt="Kartta sijainnista" width="800" height="600" />
              <div className="map-overlay">
                <span>{t('contact.loadMap')}</span>
              </div>
            </div>
          ) : (
            <iframe
              title="Google Maps Sijainti"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              // Vaihdettu kieli dynaamiseksi
              src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1767.8463876678247!2d25.53488731295968!3d64.90867807659546!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4681cd6268802819%3A0x629555239920950!2sRiihij%C3%A4rventie%206%2C%2090440%20Kempele!5e0!3m2!1s${lang}!2s${lang}!4v1716382000000!5m2!1s${lang}!2s${lang}`}
            ></iframe>
          )}
        </div>
      </div>
    </div>
  );
};

export default Contact;
